'use strict';

var availablityStatusPill = {};

exports.__exports = availablityStatusPill;
//# sourceMappingURL=availablityStatusPill.cjs.map
